/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 23/11/2023
 */
import BaseObject from "@shared/BaseObject.js";
import {yesNoDialog} from "@/core/components/Dialogs/dialog.js";
import {createDialogLazy} from "@/utils/helpers-external.js";
import NotificationHelper from "@/core/modules/NotificationHelper.js";
import TeamShareResourceManager from "@/core/modules/TeamShareResourceManager.js";
import {asArray} from "@/utils/helpers";


//to eliminate circular dependencies on vue->js->vue classes, we load all dialogs lazily
let TeamMemberPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/TeamMemberPickerDialog.vue");
let ClientPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/ClientPickerDialog.vue");
let MemberProfileUnassignDialog = () => import("@/core/modules/coach/Profile/Team/Details/AssigendScreens/MemberProfileUnassignDialog.vue");
let FilePickerDialog = () => import("@/core/components/File/FilePicker/FilePickerDialog.vue");
let FormPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/FormPickerDialog.vue");
let LegalDocPickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/LegalDocPickerDialog.vue");
let SessionTypePickerDialog = () => import("@/core/components/Dialogs/PickerDilaog/SessionTypePickerDialog.vue");
let TeamAssignClientDialog = () => import("@/core/modules/coach/Profile/Team/TeamAssignClientDialog.vue");

let teamMemberPickerDialog = createDialogLazy(TeamMemberPickerDialog)
let clientPickerDialog = createDialogLazy(ClientPickerDialog)
let memberProfileUnassignDialog = createDialogLazy(MemberProfileUnassignDialog)
let filePickerDialog = createDialogLazy(FilePickerDialog)
let formPickerDialog = createDialogLazy(FormPickerDialog)
let legalDocPickerDialog = createDialogLazy(LegalDocPickerDialog)
let sessionTypePickerDialog = createDialogLazy(SessionTypePickerDialog)
let teamAssignClientDialog = createDialogLazy(TeamAssignClientDialog)

export default class TeamAssignManager extends BaseObject {

	vueComponent = null;
	notificationHelper = null;
	teamShareResourceManager = null;

	constructor(vueComponent) {
		super();
		this.vueComponent = vueComponent;
		this.notificationHelper = new NotificationHelper(vueComponent)
		this.teamShareResourceManager = new TeamShareResourceManager(vueComponent.dataManager)
	}

	getNotifyCoachToolTip(){
		return "If checked, you'll be able to customize your invitation message on the next step."
	}

	getNotifyClientToolTip(){
		return "If checked, the client will receive an email notification about the assignment."
	}

	//client assignment
	async assignMemberToClientPickMember(clientProfile){
		console.log("TeamAssignManager.assignMemberToClientPickMember: clientProfile = ", clientProfile)
		return teamMemberPickerDialog({
			onOkLoadingText: "Assigning...",
			onOk: memberProfile => this.assignMemberToClient(memberProfile, clientProfile)
		})
	}
	async assignMemberToClientPickClient(coachProfile){
		return clientPickerDialog({
			onOkLoadingText: "Assigning...",
			onOk: clientProfile => this.assignMemberToClient(coachProfile, clientProfile)
		})
	}

	async pickTeamMember(options = {}){
		return teamMemberPickerDialog(options)
	}

	async assignMemberToClient(memberProfile, clientProfile){
		console.log("TeamAssignManager.assignMemberToClient: memberProfile = ", memberProfile, ", clientProfile = ", clientProfile)
		let res = false
		let notifyCoach = false
		let notifyClient = false
		if(memberProfile && clientProfile){
			res = await teamAssignClientDialog({
				memberProfile,
				clientProfile,
				checkboxText: "Notify coach",
				checkboxTooltipText: this.getNotifyCoachToolTip(),
				onCheckboxChanged: value => notifyCoach = value,
				checkbox2Text: "Notify client",
				checkbox2TooltipText: this.getNotifyClientToolTip(),
				onCheckbox2Changed: value => notifyClient = value,
			})
		}
		console.log("TeamAssignManager.assignMemberToClient: res1 = ", res)

		if(res){
			res = clientProfile.addAssignedTo(memberProfile)
			console.log("TeamAssignManager.assignMemberToClient: addAssignedTo res = ", res)
			if(!res){
				this.vueComponent.toastInfo(`Can't assign the client since they are already assigned to ${memberProfile.name}`, 5000)
			}
		}
		console.log("TeamAssignManager.assignMemberToClient: res2 = ", res)

		if(res){
			await Promise.all([
				this.vueComponent.dataManager.updateClientProfile(clientProfile),
				this.teamShareResourceManager.updateMemberStatsClientsCount(memberProfile, 1),
				this.teamShareResourceManager.memberShareClientResources(memberProfile, clientProfile)
			])
			if(notifyCoach){
				await this.notificationHelper.sendTeamEmailClientAssigned(memberProfile, {clientProfile})
			}
			if(notifyClient){
				await this.notificationHelper.sendClientEmailCoachAssigned(memberProfile, {clientProfile})
			}
			await this.vueComponent.toast("Assigned successfully")
		}
		return res
	}

	async unassignMemberFromClientPickMember(clientProfile){
		let shortProfileArray

		if(clientProfile.assignedTo.length <= 1){
			shortProfileArray = clientProfile.assignedTo
		} else {
			shortProfileArray = await memberProfileUnassignDialog({
				shortProfileArray: clientProfile.assignedTo,
				unassignTarget: clientProfile.name,
			})
		}
		return this.vueComponent.handleAsync(() => this._unassignMemberFromClientInternal(shortProfileArray, clientProfile))
	}
	async unassignMemberFromClient(shortOrMemberProfileArray, clientProfile){
		return this.vueComponent.handleAsync(() => this._unassignMemberFromClientInternal(shortOrMemberProfileArray, clientProfile))
	}

	async _unassignMemberFromClientInternal(shortOrMemberProfileArray, clientProfile){

		let res = false
		let notify = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}


		if(shortOrMemberProfileArray.length > 0 && clientProfile){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			console.log("TeamAssignManager._unassignMemberFromClientInternal: teamMembersStr = ", teamMembersStr)
			res = await yesNoDialog({
				checkboxText: "Notify coach",
				onCheckboxChanged: value => notify = value,
				title: `Unassign ${teamMembersStr} from the client?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to ${clientProfile.name}'s portal and to all their client's files.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			res = shortOrMemberProfileArray.reduce((res, member) => clientProfile.removeAssignedTo(member) || res, false)
		}
		if(res){
			let memberIds = shortOrMemberProfileArray.map(profile => profile.id)
			await Promise.all([
				this.vueComponent.dataManager.updateClientProfile(clientProfile),
				this.teamShareResourceManager.updateMemberStatsClientsCount(shortOrMemberProfileArray,-1),
				this.teamShareResourceManager.memberUnshareClientResourcesMultiple(memberIds, clientProfile.id)
			])

			await this.vueComponent.toast("Unassigned successfully")
			if(notify){
				let memberProfileArray = await Promise.all(shortOrMemberProfileArray.map(shortProfile => this.vueComponent.dataManager.getTeamMemberProfile(shortProfile.id)))
				await this.notificationHelper.sendTeamEmailClientUnassigned(memberProfileArray, {clientProfile})
			}
		}
		return res
	}






	//file assignment
	async assignFilesToMemberPickMember(files){
		let notify = false
		let memberProfile = await teamMemberPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning files...",
			onOk: coachProfile => this.assignFileToMember(coachProfile, files)
		})
		console.log("assignFilesToMemberPickMember: memberProfile = ", memberProfile, ", notify = ", notify)
		if(memberProfile && notify){
			await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
		}
		return memberProfile
	}
	async assignFilesToMemberPickFiles(coachProfile){
		let notify = false
		let data = await filePickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning files...",
			onOk: data => this.assignFileToMember(coachProfile, data.files)
		})
		console.log("assignFilesToMemberPickFiles: data = ", data)
		if(data){
			if(notify){
				await this.notificationHelper.sendTeamEmailResourcesAssigned(coachProfile)
			}
			return data.files
		}
		return false
	}


	async assignFileToMember(memberProfile, qwoachFiles){

		let res = false

		qwoachFiles = asArray(qwoachFiles)


		if(qwoachFiles && qwoachFiles.length > 0){
			//save extra click.
			res = true
			// let filesStr = qwoachFiles.map(file => "- " + file.name).join("<br/>")
			// res = await yesNoDialog({
			// 	title: `Assign selected files to ${memberProfile.name}?`,
			// 	message: `${memberProfile.name} will get access to the following selected files:<br/><br/>${filesStr}<br/><br/>Would you like to proceed?`,
			// 	okButton: "Assign",
			// })
		}

		if(res){
			let {count} = await this.vueComponent.dataManager.apiPostShareFilesWith({
				files: qwoachFiles,
				memberProfile,
				ownerId: this.vueComponent.dataManager.ownerId,
			})
			await this.teamShareResourceManager.updateMemberStatsFilesCount(memberProfile, count)

			await this.vueComponent.toast("Assigned successfully")
		}
		return res
	}

	async unassignFilesFromMemberPickMember(files){
		let shortProfileArray

		if(files.assignedTo.length <= 1){
			shortProfileArray = files.assignedTo
		} else {
			shortProfileArray = await memberProfileUnassignDialog({
				shortProfileArray: files.assignedTo,
				unassignTarget: "files",
			})
		}
		return this._unassignFilesFromMemberInternal(shortProfileArray, files)
	}
	async unassignFilesFromMember(shortOrMemberProfileArray, files){
		return this.vueComponent.handleAsync(this._unassignFilesFromMemberInternal(shortOrMemberProfileArray, files))
	}
	async _unassignFilesFromMemberInternal(shortOrMemberProfileArray, files){

		let res = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}

		if(!files){
			files = []
		}
		if(!Array.isArray(files)){
			files = [files]
		}

		if(shortOrMemberProfileArray.length > 0 && files.length > 0){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			let fileStr = files.length === 1 ? `file` : `files`
			res = true
			res = await yesNoDialog({
				title: `Unassign ${fileStr}?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to the ${fileStr}.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			for(let member of shortOrMemberProfileArray){
				let {count} = await this.vueComponent.dataManager.apiPostUnshareFilesWith({
					files,
					memberProfile: member,
					ownerId: this.vueComponent.dataManager.ownerId,
				})
				await this.teamShareResourceManager.updateMemberStatsFilesCount(member, -count)
			}
		}
		if(res){
			await this.vueComponent.toast("Unassigned successfully")
		}
		return res
	}







	//forms assignment
	async assignFormsToMemberPickMember(files){
		let notify = false
		let memberProfile = await teamMemberPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning files...",
			onOk: coachProfile => this.assignFormToMember(coachProfile, files)
		})
		console.log("assignFilesToMemberPickMember: memberProfile = ", memberProfile, ", notify = ", notify)
		if(memberProfile && notify){
			await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
		}
		return memberProfile
	}
	async assignFormsToMemberPickFiles(coachProfile){
		let notify = false
		let formItem = await formPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning files...",
			onOk: formItem => this.assignFormToMember(coachProfile, formItem)
		})
		console.log("assignFilesToMemberPickFiles: formItem = ", formItem)
		if(formItem){
			if(notify){
				await this.notificationHelper.sendTeamEmailResourcesAssigned(coachProfile)
			}
			return formItem
		}
		return false
	}


	async assignFormToMember(memberProfile, formItem){

		if(formItem.addSharedWithById(memberProfile.id)){
			await Promise.all([
				this.vueComponent.dataManager.updateFormItem(formItem),
				await this.teamShareResourceManager.updateMemberStatsFormsCount(memberProfile, 1)
			])
		}

		await this.vueComponent.toast("Assigned successfully")

		return true
	}


	async unassignFormItemFromMember(shortOrMemberProfileArray, formItem){
		return this.vueComponent.handleAsync(this._unassignFormItemFromMemberInternal(shortOrMemberProfileArray, formItem))
	}
	async _unassignFormItemFromMemberInternal(shortOrMemberProfileArray, formItem){

		let res = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}


		if(shortOrMemberProfileArray.length > 0){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			res = true
			res = await yesNoDialog({
				title: `Unassign form?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to the selected form.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			for(let member of shortOrMemberProfileArray){
				if(formItem.removeSharedWithById(member.id)){
					await this.teamShareResourceManager.updateMemberStatsFormsCount(member, -1)
					res = true
				}
			}
		}
		if(res){
			await this.vueComponent.dataManager.updateFormItem(formItem)
			await this.vueComponent.toast("Unassigned successfully")
		}
		return res
	}









	//legal docs assignment
	async assignLegalDocToMemberPickMember(legalDoc){
		let notify = false
		let memberProfile = await teamMemberPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning legal docs...",
			onOk: coachProfile => this.assignLegalDocToMember(coachProfile, legalDoc)
		})
		console.log("assignLegalDocToMemberPickMember: memberProfile = ", memberProfile, ", notify = ", notify)
		if(memberProfile && notify){
			await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
		}
		return memberProfile
	}
	async assignLegalDocToMemberPickLegalDoc(memberProfile){
		let notify = false
		let legalDoc = await legalDocPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning legal docs...",
			onOk: formItem => this.assignLegalDocToMember(memberProfile, formItem)
		})
		console.log("assignFilesToMemberPickFiles: legalDoc = ", legalDoc)
		if(legalDoc){
			if(notify){
				await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
			}
			return legalDoc
		}
		return false
	}


	async assignLegalDocToMember(memberProfile, legalDoc){

		if(legalDoc.addSharedWithById(memberProfile.id)){
			await this.teamShareResourceManager.updateMemberStatsLegalDocsTemplateCount(memberProfile, 1)
			await this.vueComponent.dataManager.updateDocSignTemplate(legalDoc)
		}
		await this.vueComponent.toast("Assigned successfully")

		return true
	}


	async unassignLegalDocFromMember(shortOrMemberProfileArray, formItem){
		return this.vueComponent.handleAsync(this._unassignLegalDocFromMemberInternal(shortOrMemberProfileArray, formItem))
	}
	async _unassignLegalDocFromMemberInternal(shortOrMemberProfileArray, legalDoc){

		let res = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}


		if(shortOrMemberProfileArray.length > 0){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			res = true
			res = await yesNoDialog({
				title: `Unassign legal doc?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to the selected legal document.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			for(let member of shortOrMemberProfileArray){
				if(legalDoc.removeSharedWithById(member.id)){
					await this.teamShareResourceManager.updateMemberStatsLegalDocsTemplateCount(member, -1)
					res = true
				}
			}
		}
		if(res){
			await this.vueComponent.dataManager.updateDocSignTemplate(legalDoc)
			await this.vueComponent.toast("Unassigned successfully")
		}
		return res
	}








	//completed legal docs assignment
	async assignCompletedLegalDocToMemberPickMember(legalDoc){
		let notify = false
		let memberProfile = await teamMemberPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning legal docs...",
			onOk: coachProfile => this.assignCompletedLegalDocToMember(coachProfile, legalDoc)
		})
		console.log("assignCompletedLegalDocToMemberPickMember: memberProfile = ", memberProfile, ", notify = ", notify)
		if(memberProfile && notify){
			await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
		}
		return memberProfile
	}
	async assignCompletedLegalDocToMemberPickLegalDoc(memberProfile){
		let notify = false
		let legalDoc = await legalDocPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning legal docs...",
			onOk: formItem => this.assignCompletedLegalDocToMember(memberProfile, formItem)
		})
		console.log("assignCompletedLegalDocToMemberPickLegalDoc: legalDoc = ", legalDoc)
		if(legalDoc){
			if(notify){
				await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
			}
			return legalDoc
		}
		return false
	}


	async assignCompletedLegalDocToMember(memberProfile, legalDoc){

		if(legalDoc.addSharedWithById(memberProfile.id)){
			await this.teamShareResourceManager.updateMemberStatsSignedLegalDocsCount(memberProfile, 1)
			await this.vueComponent.dataManager.updateContract(legalDoc)
		}
		await this.vueComponent.toast("Assigned successfully")

		return true
	}


	async unassignCompletedLegalDocFromMember(shortOrMemberProfileArray, legalDoc){
		return this.vueComponent.handleAsync(this._unassignCompletedLegalDocFromMemberInternal(shortOrMemberProfileArray, legalDoc))
	}
	async _unassignCompletedLegalDocFromMemberInternal(shortOrMemberProfileArray, legalDoc){

		let res = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}


		if(shortOrMemberProfileArray.length > 0){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			res = true
			res = await yesNoDialog({
				title: `Unassign completed legal doc?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to the selected legal document.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			for(let member of shortOrMemberProfileArray){
				if(legalDoc.removeSharedWithById(member.id)){
					await this.teamShareResourceManager.updateMemberStatsSignedLegalDocsCount(member, -1)
					res = true
				}
			}
		}
		if(res){
			await this.vueComponent.dataManager.updateContract(legalDoc)
			await this.vueComponent.toast("Unassigned successfully")
		}
		return res
	}






	//session type assignment
	async assignSessionTypeToMemberPickMember(sessionType){
		let notify = false
		let memberProfile = await teamMemberPickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning session type...",
			onOk: coachProfile => this.assignSessionTypeToMember(coachProfile, sessionType)
		})
		console.log("assignLegalDocToMemberPickMember: memberProfile = ", memberProfile, ", notify = ", notify)
		if(memberProfile && notify){
			await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
		}
		return memberProfile
	}
	async assignSessionTypeToMemberPickSessionType(memberProfile){
		let notify = false
		let sessionType = await sessionTypePickerDialog({
			checkboxText: "Notify member",
			onCheckboxChanged: value => notify = value,
			onOkLoadingText: "Assigning session type...",
			onOk: formItem => this.assignSessionTypeToMember(memberProfile, formItem)
		})
		if(sessionType){
			if(notify){
				await this.notificationHelper.sendTeamEmailResourcesAssigned(memberProfile)
			}
			return sessionType
		}
		return false
	}


	async assignSessionTypeToMember(memberProfile, sessionType){

		if(sessionType.addSharedWithById(memberProfile.id)){
			await this.teamShareResourceManager.updateMemberStatsSessionTypesCount(memberProfile, 1)
			await this.vueComponent.dataManager.updateEventType(sessionType)
		}
		await this.vueComponent.toast("Assigned successfully")

		return true
	}

	async unassignSessionTypeFromMember(shortOrMemberProfileArray, sessionType){
		return this.vueComponent.handleAsync(this._unassignSessionTypeFromMemberInternal(shortOrMemberProfileArray, sessionType))
	}
	async _unassignSessionTypeFromMemberInternal(shortOrMemberProfileArray, sessionType){

		let res = false

		if(!shortOrMemberProfileArray){
			shortOrMemberProfileArray = []
		}
		if(!Array.isArray(shortOrMemberProfileArray)){
			shortOrMemberProfileArray = [shortOrMemberProfileArray]
		}


		if(shortOrMemberProfileArray.length > 0){
			let isSingle = shortOrMemberProfileArray.length === 1
			let teamMembersStr = isSingle ? `${shortOrMemberProfileArray[0].name}`: `the selected team members`
			res = true
			res = await yesNoDialog({
				title: `Unassign session type?`,
				message: `${teamMembersStr.qwCapitalize()} will lose access to the selected session type.<br/><br/>Would you like to proceed?`,
				yesButton: "Unassign",
			})
		}

		if(res){
			for(let member of shortOrMemberProfileArray){
				if(sessionType.removeSharedWithById(member.id)){
					await this.teamShareResourceManager.updateMemberStatsSessionTypesCount(member, -1)
					res = true
				}
			}
		}
		if(res){
			await this.vueComponent.dataManager.updateEventType(sessionType)
			await this.vueComponent.toast("Unassigned successfully")
		}
		return res
	}


	async updateMemberStatsClientsCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsClientsCount(shortMemberProfiles, valueDiff)
	}
	async updateMemberStatsFilesCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsFilesCount(shortMemberProfiles, valueDiff)
	}
	async updateMemberStatsFormsCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsFormsCount(shortMemberProfiles, valueDiff)
	}
	async updateMemberStatsLegalDocsTemplateCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsLegalDocsTemplateCount(shortMemberProfiles, valueDiff)
	}
	async updateMemberStatsSignedLegalDocsCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsSignedLegalDocsCount(shortMemberProfiles, valueDiff)
	}
	async updateMemberStatsSessionTypesCount(shortMemberProfiles, valueDiff = 1){
		return this.teamShareResourceManager.updateMemberStatsSessionTypesCount(shortMemberProfiles, valueDiff)
	}


	// async teamMemberPickerDialog(...args){
	// 	if(!this.teamMemberPickerDialogInstance){
	// 		let TeamMemberPickerDialogClass = await TeamMemberPickerDialog()
	// 		this.teamMemberPickerDialogInstance = createDialog(TeamMemberPickerDialogClass)(...args)
	// 	}
	// 	return this.teamMemberPickerDialogInstance
	// }

	// async clientPickerDialog(...args){
	// 	if(!this.clientPickerDialogInstance){
	// 		let ClientPickerDialogClass = await ClientPickerDialog()
	// 		this.clientPickerDialogInstance = createDialog(ClientPickerDialogClass)(...args)
	// 	}
	// 	return this.clientPickerDialogInstance
	// }
}
